export const CUSTOMER_ROLE = 0;
export const SUPPLIER_ROLE = 1;
export const ADMIN_ROLE = 2;

export const menuItems = [
    //Customer
    {
        id: 1,
        label: 'Accueil',
        icon: 'fas fa-home',
        subItems:[],
        link: '/',
        role:CUSTOMER_ROLE
    },
    // {
    //     id: 6,
    //     label: 'Offres Permanentes',
    //     icon: 'fas fa-briefcase-medical',
    //     isUiElement: true,
    //     role:CUSTOMER_ROLE,
    //     subItems: [
    //         {
    //             id: 8,
    //             label: 'Offres par laboratoires',
    //             link: '/suppliers/list',
    //             parentId: 6
    //         },
            
            
    //     ]
    // },


    {
        id: 100,
        label: 'Nos Offres',
        icon: 'fas fa-hand-holding-usd',
        role:CUSTOMER_ROLE,
        subItems: [
            {
                id: 101,
                label: 'Offres Permanentes',
                link: '/suppliers/list',
                //icon: 'fas fa-briefcase-medical',
            },
            {
                id: 102,
                label: 'Offres Provisoires & Groupées',
                link: '/promotions/list',
                //icon: 'fas fa-hand-holding-usd',
            },
            // {
            //     id: 103,
            //     label: 'Offres Groupées',
            //     link: '/promotions/grouped-list',
            //     //icon: 'fas fa-people-arrows',
            // },
        ]
    },




    {
        id: 99,
        label: 'LGP Negoce',
        link: '/promotions/grouped-list-lgp',
        icon: 'fas fa-star text-warning',
        subItems:[],
        role:CUSTOMER_ROLE
    },


    {
        id: 25,
        label: 'Commandes',
        icon: 'fas fa-dolly',
        role:CUSTOMER_ROLE,
        subItems: [
            {
                id: 26,
                label: 'Liste des commandes',
                link: '/orders/list',
                parentId: 25
            },
            {
                id: 27,
                label: 'Liste des factures',
                link: '/invoices/list',
                parentId: 25
            },
            {
                id: 28,
                label: "Rapports & Stats",
                link: "/reporting",
                parentId: 25
            },
        ]
    },
    {
        id: 70,
        icon: 'fas fa-users',
        label: 'Membres LGP',
        role:CUSTOMER_ROLE,
        subItems: [
            {
                id: 26,
                label: 'Echanges',
                link: '/exchanges/list',
                parentId: 25
            },
            {
                id: 28,
                label: "Annuaire",
                link: "/directory",
                parentId: 25
            },
            /*{
                id: 27,
                label: 'Actualites',
                link: '/news',
                parentId: 25
            },*/
            {
                id: 29,
                label: 'Liste des prestataires',
                link: '/providers/list',
                parentId: 25
            },


            {
                id: 30,
                label: 'Réclamations & Suggestions',
                link: '/newclaim',
                parentId: 25
            },
        ]
    },
    {
        id: 97,
        label: 'Merchandising',
        icon: 'fas fa-tv',
        subItems:[],
        link:"/merchandising",
        role:CUSTOMER_ROLE,
    },

    
    //Supplier
    {
        id: 12,
        label: 'Accueil',
        icon: 'fas fa-home',
        subItems:[],
        link: '/',
        role:SUPPLIER_ROLE
    },
    {
        id: 62,
        label: 'Articles',
        icon: 'fas fa-list',
        isUiElement: true,
        link:'/items',
        role:SUPPLIER_ROLE,

    },
    {
        id: 97,
        label: 'Offres / Promo',
        icon: 'fas fa-hand-holding-usd',
        subItems:[],
        link:"/supplierpromotions",
        role:SUPPLIER_ROLE,
    },
    {
        id: 252,
        label: 'Commandes',
        icon: 'fas fa-dolly',
        role:SUPPLIER_ROLE,
        subItems: [
            {
                id: 262,
                label: 'Liste des commandes',
                link: '/orders/list',
                parentId: 252
            },
            {
                id: 272,
                label: 'Factures des clients',
                link: '/invoices/list',
                parentId: 252
            },
            {
                id: 274,
                label: 'Service de Facturation',
                link: '/local-invoices/list',
                parentId: 252,
                isInvoiceSupported: true                
            },
        ]
        
    },
    {
        id: 702,
        icon: 'fas fa-users',
        label: 'Membres LGP',
        role:SUPPLIER_ROLE,
        subItems: [
            /*{
                id: 272,
                label: 'Actualites',
                link: '/news',
                parentId: 252
            },*/
            {
                id: 282,
                label: "Annuaire",
                link: "/directory",
                parentId: 252
            },
        ]
    },

    //Admin
    {
        id: 13,
        label: 'Accueil',
        icon: 'fas fa-home',
        subItems:[],
        link: '/admin',
        role:ADMIN_ROLE
    },
    {
        id: 253,
        label: 'Commandes',
        icon: 'fas fa-dolly',
        role:ADMIN_ROLE,
        subItems: [
            {
                id: 263,
                label: 'Liste des commandes',
                link: '/listOfOrders',
                parentId: 253
            },
            {
                id: 273,
                label: 'Liste des factures',
                link: '/invoices/list',
                parentId: 253
            },
        ]
    },

    {
        id: 984,
        label: 'Offres',
        link: '/promotions/list',
        icon: 'fas fa-hand-holding-usd',
        subItems:[],
        role:ADMIN_ROLE
    },

    // {
    //     id: 985,
    //     label: 'Offres Groupées',
    //     link: '/promotions/grouped-list',
    //     icon: 'fas fa-people-arrows',
    //     subItems:[],
    //     role:ADMIN_ROLE
    // },

    {
        id: 703,
        icon: 'fas fa-users',
        label: 'Membres LGP',
        role:ADMIN_ROLE,
        subItems: [
            {
                id: 263,
                label: 'Abonnements',
                link: '/listOfUsers',
                parentId: 703
            },
            /*{
                id: 273,
                label: 'Actualites',
                link: '/news',
                parentId: 703
            },*/
            {
                id: 283,
                label: "Annuaire",
                link: "/directory",
                parentId: 703
            },

            {
                id: 284,
                label: 'Réclamations & Suggestions',
                link: '/newclaim',
                parentId: 703
            },
        ]
    },
    {
        id: 973,
        label: 'Articles',
        icon: 'fas fa-list',
        subItems:[],
        link:"/listOfProducts",
        role:ADMIN_ROLE,
    },
    {
        id: 983,
        label: 'Bannières',
        icon: 'fab fa-adversal',
        subItems:[],
        link:"/banners",
        role:ADMIN_ROLE,
    },

];

